import { render, staticRenderFns } from "./SettingsLocalisationCountriesAllowedTelephoneList.vue?vue&type=template&id=0d558104&"
import script from "./SettingsLocalisationCountriesAllowedTelephoneList.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocalisationCountriesAllowedTelephoneList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports